import { HttpMethods } from '../apiService/baseEndpoint'
import { AccountsEndpoint } from './endpoint'

export const accountsRequest = async (): Promise<any> => {
  const endpoint = new AccountsEndpoint<undefined, undefined>('', HttpMethods.GET, undefined)
  return endpoint.execute()
}
